export const homePath = '/login';
export const size = ['300px', '260px'];
